module.exports = __webpack_public_path__ + "assets/CTranslateCircleDetailed.140e8d123ae1ca652fcd5b5045e61506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CTranslateCircleDetailed.png
// module id = 476
// module chunks = 0